export const getApiBaseUrl = () => {
    // In Capacitor, we can't use relative URLs like /api
    // We must use the absolute URL of the production server or local dev server
    if (typeof window !== 'undefined') {
        const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        const isCapacitor = window.location.protocol === 'capacitor:' || window.location.protocol === 'file:';

        // Standard web browser environment: always use current origin to avoid CORS redirect mismatch
        if (!isCapacitor) {
            return window.location.origin;
        }

        // Capacitor environment: use NEXT_PUBLIC_APP_URL if defined, otherwise fallback
        if (process.env.NEXT_PUBLIC_APP_URL) {
            const appUrl = process.env.NEXT_PUBLIC_APP_URL.replace(/\/$/, '');
            const isAppUrlLocal = appUrl.includes('localhost') || appUrl.includes('127.0.0.1');
            if (!isAppUrlLocal || isLocalhost || isCapacitor) {
                return appUrl;
            }
        }
        return 'https://getxobelaeskola.cloud';
    }

    // In standard web environment, use relative paths
    return '';
};

export const apiUrl = (path: string) => {
    if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
    }

    const base = getApiBaseUrl();
    const cleanPath = path.startsWith('/') ? path : `/${path}`;

    // Fix common path errors: remove /academy/ prefix if it was incorrectly added
    const fixedPath = cleanPath.replace(/^\/api\/academy\//, '/api/');

    return `${base}${fixedPath}`;
};
